<!--
 * @Description: 批量添加
 * @LastEditors: Please set LastEditors
 * @Date: 2020-11-26 17:01:28
-->
<template>
  <div>
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="ruleForm"
    >
      <el-form-item label label-width="0">
        <el-upload
          class="upload-demo"
          ref="upload"
          :action="importData"
          :on-success="handleSuccess"
          :on-exceed="uploadExc"
          :on-error="uploadError"
          :on-change="fileChange"
          :on-remove="fileRemove"
          name="file"
          :multiple="false"
          :limit="1"
          :auto-upload="false"
          :data="ruleForm"
          :headers="headers"
        >
          <el-button style="font-size:14px;" slot="trigger" type="primary">
            上传个体名单
          </el-button>
          <el-button
            style="font-size:14px;margin-left: 30px"
            type="text"
            icon="el-icon-download"
            @click="downLoad"
          >
            名单模板下载
          </el-button>
          <p
            style="color:red;font-size:12px;line-height: 1.5;width: 80%;margin-top:20px"
          >
            注：项目执行人不能是“公职人员”“军人”。请确定填写正确的个体信息。添加后的用户本月项目将被直接邀请入驻。
          </p>
        </el-upload>
      </el-form-item>
    </el-form>
    <div style="text-align:center">
      <el-button type="primary" @click="confirm" :loading="btLoading">
        确认
      </el-button>
      <el-button @click="close">取消</el-button>
    </div>
  </div>
</template>

<script>
import {
  downLoadTemplate,
  peopleMgmt,
  projectPersonnelManagement
} from '@/api/ajax';
import { getToken } from '@/tools/auth';
import { btLoading } from '@/Mixin/btLoading';
import Config from '@/config/index';
import preSubmit from './add-users-pre';
import createExtend from '@/components/createExtend.js';
import { checkProjectTaskPlanExcel } from '../../utils/index.js';

export default {
  name: 'AddUsers',
  inject: ['_parent'], // src\page\project-personnel-inside\list\index.vue
  mixins: [btLoading],
  components: {
    // eslint-disable-next-line vue/no-unused-components
    preSubmit
  },
  data() {
    return {
      confirmDialog: false,
      hasFile: false,
      headers: {},
      ruleForm: {},
      rules: {
        taskDate: [
          {
            required: true,
            message: '不能为空',
            trigger: 'blur'
          }
        ],
        finishSum: [
          {
            required: true,
            message: '不能为空',
            trigger: 'blur'
          }
        ]
      },
      searchQuery: {}
    };
  },
  watch: {},
  computed: {
    importData() {
      return projectPersonnelManagement.importUserOrTask;
    }
  },
  methods: {
    handleSuccess(response) {
      if (response.status == 1) {
        this.$notify({
          title: '成功',
          message: response.message,
          type: 'success'
        });
        this.$refs.upload.clearFiles();
        this.$emit('task-close', false);
        // 刷新父级列表，应该在引用中使用emit
        this._parent.$children[0].searchEvent();
        this.$xrkDialog.remove();
      } else if (response.status == 2) {
        this.$refs.upload.clearFiles();
        // 上传错误
        const h = this.$createElement;
        const _this = this;
        const redisKey = response.data;
        this.$msgbox({
          title: '导入错误',
          message: h('p', null, [
            h('span', null, '当前表单导入个体有误,点击 '),
            h(
              'i',
              {
                style: 'color: blue;cursor:pointer',
                on: {
                  click: function() {
                    _this.$downloadFile(
                      `${peopleMgmt.uploadError}?redisKey=${redisKey}`,
                      true
                    );
                  }
                }
              },
              '下载 '
            ),
            h('span', null, '查看错误信息')
          ]),
          showCancelButton: true,
          confirmButtonText: '关闭',
          cancelButtonText: ''
        }).then(action => {
          // this.$message({
          //   type: 'info',
          //   message: 'action: ' + action
          // });
        });
      } else {
        this.$notify({
          title: '错误',
          message: response.message,
          type: 'error'
        });
        this.$refs.upload.clearFiles();
      }
      this.SET_BTLOADING(false);
    },
    confirm() {
      if (!this.hasFile) {
        this.$message({
          message: '请先上传文件',
          type: 'warning'
        });
        return false;
      }
      // 检查文件中人员标签是否为空
      checkProjectTaskPlanExcel.call(
        this,
        this.$refs.upload.uploadFiles[0].raw,
        this.$store.state.homeProject.id,
        2,
        () => {
          const confirm = createExtend(preSubmit);
          confirm.$on('ok', patternType => {
            confirm.remove();
            this.ruleForm.patternType = patternType;
            this.SET_BTLOADING(true);
            this.$refs.upload.submit();
          });
        }
      );
    },
    downLoad() {
      window.open(
        `${downLoadTemplate.personnelDownLoad({}, true)}?projectId=${
          this.$route.query.id
        }`
      );
    },
    close() {
      this.$xrkDialog.remove();
    },
    uploadExc() {
      this.$notify({
        title: '失败',
        message: '只能上传一个文件，如若修改请手动删除当前上传文件',
        type: 'error'
      });
    },
    uploadError() {
      this.SET_BTLOADING(false);
    },
    fileChange(file, fileList) {
      if (fileList.length) {
        this.hasFile = true;
      } else {
        this.hasFile = false;
      }
    },
    fileRemove() {
      this.hasFile = false;
    }
  },
  created() {
    this.headers[Config.token] = getToken();
    this.ruleForm = {
      // fenpeiId: this.$route.query.fenpeiId,
      projectId: this.$route.query.id,
      importType: 0
    };
  },
  beforeDestroy() {}
};
</script>
